module.exports = __webpack_public_path__ + "static/Freestep-1f7cec0b88c154f7b6d2e473d95390e3.jpg";